import { render } from "./Challenges.vue?vue&type=template&id=3c052f00&scoped=true"
import script from "./Challenges.vue?vue&type=script&lang=js"
export * from "./Challenges.vue?vue&type=script&lang=js"

import "./Challenges.vue?vue&type=style&index=0&id=3c052f00&scoped=true&lang=css"

import exportComponent from "/Users/ffavreau/www/canton-dans-le-bouillon/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c052f00"]])

export default __exports__